<po-page-list #pageListComponent [p-breadcrumb]="breadcrumb" p-title="Processamento de Fichas"
  [p-disclaimer-group]="disclaimerGroup" [p-actions]="pageActions" [p-filter]="filterSettings" p-subtitle="Consulte os dados cadastrados no sistema.">

  <div class="page-summary">
    <div class="page-summary-icon">
      <i class="an an-gear-six"></i>
    </div>
    <div class="page-summary-text">
      <p class="po-font-subtitle">Verifique todos os processos de módulos incluídos no sistema.</p>
      <p class="page-summary-hint">Os processamentos são executados em segundo plano. Utilize <b>Atualizar</b> para verificar o status.</p>
    </div>
  </div>

  <po-divider></po-divider>

  <div class="po-row po-mb-4 shadow">
    <div>
      <po-loading-overlay [hidden]="isHideLoading"></po-loading-overlay>
    </div>
    <po-table #dynamicTable p-container="border" [p-actions]="actions" class="po-mr-1 po-ml-1 po-lg-12" #wppTable
      (p-show-more)="loadMore()"
      [p-show-more-disabled]="!moreItens" p-striped="true" p-text-wrap="false"
      [p-loading-show-more]="!isHideLoading"
      [p-spacing]="poTableColumnSpacing" p-container="border" p-hide-columns-manager="false"
      [p-columns]="columns" [p-items]="tableItens">
      <ng-template p-table-column-template [p-property]="'tempoTotalSegundos'" let-rowItem>
        <span class="tempo-badge">
          <i class="an an-clock"></i>
          @if (rowItem < 60) {
            {{ rowItem.toFixed(0) }} seg
          }
          @if (rowItem >= 60 && rowItem < 3600) {
            {{ (rowItem / 60).toFixed(2) }} min
          }
          @if (rowItem >= 3600) {
            {{ (rowItem / 3600).toFixed(2) }} h
          }
        </span>
      </ng-template>
      <ng-template p-table-column-template [p-property]="'nomeCliente'" let-value>
        <span [innerText]="value" class="po-font-text-large-bold"></span>
      </ng-template>
    </po-table>
  </div>
</po-page-list>

  <po-modal #modalDetalhes p-title="Detalhes do Processamento" p-icon="an an-gear-six" [p-size]="tamanhoModal">

    <div class="modal-detail-header">
      <div class="modal-detail-badges">
        <span class="badge component"><i class="an an-hash"></i> Processo {{atualJob?.id}}</span>
        <span class="badge component"><i class="an an-calendar-blank"></i> {{atualJob?.periodoArq}}</span>
        @if (atualJob?.status === 'Concluido') {
          <span class="badge success">{{atualJob?.status}}</span>
        }
        @if (atualJob?.status === 'Processando') {
          <span class="badge warning">{{atualJob?.status}}</span>
        }
        @if (atualJob?.status === 'Erro') {
          <span class="badge error">{{atualJob?.status}}</span>
        }
        @if (atualJob?.status === 'Cancelado') {
          <span class="badge warning">{{atualJob?.status}}</span>
        }
        @if (atualJob?.status === 'Pendente') {
          <span class="badge">{{atualJob?.status}}</span>
        }
      </div>
    </div>

    <div class="modal-detail-grid po-mt-3">
      <div class="modal-detail-field">
        <span class="modal-detail-label"><i class="an an-buildings"></i> Cliente</span>
        <span class="modal-detail-value">{{atualJob?.nomeCliente}}</span>
      </div>
      <div class="modal-detail-field">
        <span class="modal-detail-label"><i class="an an-clock"></i> Iniciado em</span>
        <span class="modal-detail-value">{{atualJob?.dataInicio | date: 'dd/MM/yyyy HH:mm'}}</span>
      </div>
      <div class="modal-detail-field">
        <span class="modal-detail-label"><i class="an an-timer"></i> Tempo Total</span>
        <span class="modal-detail-value">{{atualJob?.tempoTotalSegundos}} segundos</span>
      </div>
    </div>

    @if (atualJob?.status === 'Processando') {
      <div class="modal-status-card processing po-mt-3">
        <div class="modal-status-card-icon">
          <i class="an an-spinner"></i>
        </div>
        <div class="modal-status-card-content">
          <span class="modal-status-card-title">Processamento em andamento</span>
          <p>Etapa Atual: <span class="badge service">{{atualJob?.stepAtual}}</span></p>
          <div class="po-mt-2">
            <po-button p-label="Cancelar Processo" p-icon="an an-stop-circle" p-kind="tertiary" p-size="small" (p-click)="cancelarProcessamento(atualJob)"></po-button>
          </div>
        </div>
      </div>
    }

    @if (atualJob?.status === 'Erro') {
      <div class="modal-status-card error po-mt-3">
        <div class="modal-status-card-icon">
          <i class="an an-warning-circle"></i>
        </div>
        <div class="modal-status-card-content">
          <span class="modal-status-card-title">Falha no processamento</span>
          <p>{{atualJob?.erroMensagem}}</p>
          @if (podeRegerarTxt) {
            <p class="po-mt-1">A falha ocorreu na etapa final de geração do arquivo. Você pode regerar apenas o TXT, sem refazer o cálculo dos módulos.</p>
          }
          <div class="po-mt-2">
            @if (podeRegerarTxt) {
              <po-button p-label="Regerar Arquivo TXT" p-icon="an an-file-text" p-kind="primary" p-size="small" (p-click)="regerarTxt(atualJob)"></po-button>
            }
            <po-button p-label="Reprocessar" p-icon="an an-arrow-counter-clockwise" p-kind="tertiary" p-size="small" (p-click)="confirmReprocessamento(atualJob)"></po-button>
          </div>
        </div>
      </div>
    }

    @if (atualJob?.status === 'Concluido') {
      <div class="modal-status-card success po-mt-3">
        <div class="modal-status-card-icon">
          <i class="an an-check-circle"></i>
        </div>
        <div class="modal-status-card-content">
          <span class="modal-status-card-title">Processamento concluído</span>
          <p>Finalizado em: <b>{{atualJob?.dataFim | date: 'dd/MM/yyyy HH:mm'}}</b></p>
          <div class="po-mt-2">
            <po-button p-label="Baixar Resultado" p-icon="an an-download-simple" p-kind="tertiary" p-size="small" (p-click)="baixarArquivo(atualJob)"></po-button>
          </div>
        </div>
      </div>
    }

    <div class="modal-section-title po-mt-4">
      <i class="an an-list-checks"></i>
      <span>Etapas do Processamento</span>
    </div>

    <po-table class="po-mt-2" p-container="border" [p-columns]="columnsDetalhes" [p-items]="itensDetalhes" p-striped="true"
      p-text-wrap="false" p-hide-columns-manager="true">
    </po-table>

    <po-modal-footer>
      <po-button p-label="Atualizar" p-icon="an an-arrow-clockwise" p-kind="secondary" (p-click)="atualizarSteps()"></po-button>
      <po-button p-label="Fechar" p-kind="primary" (p-click)="modalDetalhes.close()"></po-button>
    </po-modal-footer>
  </po-modal>


<po-modal
  #modalCancelamentoProcesso
  [p-primary-action]="primaryAction"
  [p-secondary-action]="secondaryAction"
  p-title="Cancelar processamento">
  Você tem certeza que deseja cancelar o processo <b>{{atualJob?.id}}</b> do cliente <b>{{atualJob?.nomeCliente}}</b>?
</po-modal>
